import React from "react";
import "../styles/RentTutorialStriemoKey.css";
import { useTranslation } from 'react-i18next';

const ReturnTutorialCwalk = () => {
  const { t } = useTranslation();
    return (
      <main>
        <section class="app__return" id="appreturn-jp">
          <div class="inner-app">
            <h2 class="section-ttl">{t('Thank you for using')}</h2>
            <ul class="rental-warapper">
            <li class="rental-list">
              <div class="use__img-area">
                <figure class="use__img"><img src="/images/cwalk/parking.png" alt={t('parking')} /></figure>
              </div>
              <div class="rental__ttl-area ">
                <h3 class="rental__ttl">{t('1.Apply the parking brake of C+walkT.')}</h3>
              </div>
                <p class="rental-discription">
                  {t("※It's the small square lever in front of the brake lever!")}
                </p>
              </li>
              <li class="rental-list">
                <div class="use__img-area">
                  <figure class="use__img"><img src="/images/cwalk/btn.png" alt={t('power button')} /></figure>
                </div>
                <div class="rental__ttl-area">
                  <h3 class="rental__ttl">{t('2.Please turn off the power of C+walkT.')}</h3>
                </div>
              </li>
              <li class="rental-list">
                <div class="use__img-area">
                  <figure class="use__img"><img src="/images/cwalk/key-return.png" alt={t('key return')} /></figure>
                </div>
                <div class="rental__ttl-area">
                  <h3 class="rental__ttl">{t('3.Please return the key to the key box.')}</h3>
                </div>
              </li>
            </ul>
          </div>
        </section>
      </main>
    );
};

export default ReturnTutorialCwalk;
